import React, { useState } from 'react'
import { Container } from 'react-bootstrap'
import { Form as FinalForm } from 'react-final-form'

import LoaderOverlay from '../../../1stlog-ui/src/components/LoaderOverlay'
import { request } from '../../../1stlog-ui/src/utils'
import Form, { stringifyValues } from './Form'

const Interfaces = (props) => {
  const {} = props

  const [form, setForm] = useState()

  const [isLoading, setIsLoading] = useState(false)

  const onSubmit = async (values) => {
    try {
      setIsLoading(true)
      const formData = new FormData()
      formData.append('data', JSON.stringify(stringifyValues(values)))

      const response = await request({
        method: 'POST',
        url: '/data/export/transferlist',
        data: formData,
        responseType: 'blob',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })

      const { data } = response

      // downloadBlob(response, {
      //   target: '_blank',
      // })

      const url = window.URL.createObjectURL(
        new Blob([data], { type: 'application/pdf' }),
      )
      window.open(url, '_blank')
    } catch (err) {
      console.error('Failed to export transferlist', err)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Container>
      <LoaderOverlay isLoading={isLoading} fullscreen>
        {i18n.t('transfer_list_being_created', 'Transferliste wird erstellt')}
        ...
      </LoaderOverlay>
      <FinalForm
        onSubmit={onSubmit}
        subscription={{ submitting: true, pristine: true }}
      >
        {(formProps) => {
          return (
            <Form
              {...formProps}
              getFormApi={setForm}
              initialValues={{
                dateType: 'shipping',
                sortBy: 'creationTime',
                timerange: { startTime: '00:00', endTime: '23:59' },
              }}
              isLoading={isLoading}
            />
          )
        }}
      </FinalForm>
    </Container>
  )
}

export default Interfaces
